import { AcceptedFileTypes } from 'src/app/shared/types/AcceptedFileTypes';

export const TOKEN_EXCL_LIST: string[] = [];
export const ACRONYMNS = new Set(['VDR']);
export const monthDropDownValues = {
  '01': 'January',
  '02': 'February',
  '03': 'March',
  '04': 'April',
  '05': 'May',
  '06': 'June',
  '07': 'July',
  '08': 'August',
  '09': 'September',
  '10': 'October',
  '11': 'November',
  '12': 'December',
};

export const DELAY_STATUS = {
  REPORTED: 'Reported',
  PENDING_APPROVAL: 'Pending Approval',
  PENDING_ANALYSIS: 'Pending Analysis',
  PENDING_ACTION: 'Pending Action',
  PENDING_CLOSURE: 'Pending Closure',
};

export const ICONS = {
  CLOSED: 'Closed',
  OPEN_ITEMS: 'Open Items',
  PENDING: 'Pending',
  DATABASE: 'database',
  COMMENT: 'comment',
  BAR_CHART: 'bar_chart',
  DASHBOARD: 'dashboard',
  DOWNLOAD: 'download',
  OPEN_IN_NEW: 'open_in_new',
  FILTER_ALT: 'filter_alt',
  CALENDAR: 'calendar_today',
  SHIELD: 'shield',
  IMAGE: 'image',
  HOME: 'home',
  SHOW_CHART: 'show_chart',
  FILE_COPY: 'file_copy',
  MENU: 'menu',
  KEYBOARD_ARROW_DOWN: 'keyboard_arrow_down',
  SETTINGS: 'settings',
  GROUP: 'group',
  LOGOUT: 'logout',
  CLOSE: 'close',
  DELETE: 'delete',
  ADD: 'add',
  ADD_CIRCLE: 'add_circle',
  SEND: 'send',
  KEYBOARD_ARROW_UP: 'keyboard_arrow_up',
  CHECK: 'check',
  PDF: 'picture_as_pdf',
  CHECK_CIRCLE: 'check_circle',
  INFO: 'info',
  ERROR: 'error',
  PROGRESS_ACTIVITY: 'progress_activity',
  CONTENT_PASTE: 'content_paste',
  BROWSE_ACTIVITY: 'browse_activity',
  SYNC: 'sync',
  VISIBILITY: 'visibility',
  NOTE_ADD: 'note_add',
  TABLE: 'table',
  CALENDAR_TODAY: 'calendar_today',
  EDIT: 'edit',
  VIDEOCAM: 'videocam',
  ARROW_DROP_UP: 'arrow_drop_up',
  OPEN_IN_FULL: 'open_in_full',
  KEYBOARD_ARROW_LEFT: 'keyboard_arrow_left',
  KEYBOARD_ARROW_RIGHT: 'keyboard_arrow_right',
  CONTACT_PAGE: 'contact_page',
  SCHEDULE: 'schedule',
  QUESTION_MARK: 'question_mark',
  WINDOW: 'window',
  HISTORY: 'history',
  CHAT: 'chat',
  UPLOAD: 'upload',
  DESCRIPTION: 'description',
  MORE_VERT: 'more_vert',
  PERSON: 'person',
  UPGRADE: 'upgrade',
  KEBAB_HR: 'more_horiz',
  TACTIC: 'tactic',
  COMPARE: 'compare_arrows',
  SEARCH: 'search',
  WORKFLOW: 'conversion_path',
  NOTIFICATIONS: 'notifications',
  WARNING: 'warning',
  PREVIEW: 'preview',
  ADD_ALERT: 'add_alert',
  MENUBOOK:'menu_book',
  CONTACT_SUPPORT: 'contact_support',
  HELP: 'help',
  DEFAULT: undefined,
};

export const MANUAL_FILE_STATUS = {
  INITIATED: 'INITIATED',
  INPROGRESS: 'INPROGRESS',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

export const USER_CHECK = {
  SUPER_ADMIN: 'super-admin',
  PROJECT_ADMIN: (projectCode: string) =>
    `project-admin-${projectCode}`.toLowerCase(),
  USER_P1: (projectCode: string) => `p1-${projectCode}`.toLowerCase(),
  USER_P2: (projectCode: string) => `p2-${projectCode}`.toLowerCase(),
};

export const FILE_TYPE_MAPPER: Record<AcceptedFileTypes, string> = {
  '.xlsx': 'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.csv': 'csv',
  'application/msword': 'msword',
  '.txt': 'plain',
  'image/*': 'image',
  pdf: 'pdf',
  '*': 'all',
  '.mp4': 'video/mp4',
};

export const SUPER_ADMIN_URLS = [
  '/',
  '/dashboard-mapping',
  '/onboard-project',
  '/assign-super-admin',
];

export const LAST_REFRESH_DATE_URLS = [  
  '/admin-wizard/',
  '/dashboard-mapping',
  '/onboard-project',
  '/assign-super-admin',
  '/assign-user'
]
export const PROJECT_ADMIN_URLS = ['/admin-wizard'];

export const STATUS_CODES = {
  UNAUTHORIZED: 403,
  NOT_FOUND: 404,
};

export const dashboardRedirectUrl =
  'https://app.powerbi.com/groups/me/apps/7b51081f-4913-4f87-a046-dcb1ca33accb?experience=power-bi';

export const FORM_INPUT_RULE_MAPPER = {
  checkbox: ['required'],
  date: ['required', 'pastOnly', 'futureOnly', 'maxToday'],
  datetime: ['required', 'pastOnly', 'futureOnly'],
  dropdown_dynamic: ['required'],
  dropdown_static: ['required'],
  file: ['required', 'fileType', 'maxFileSize'],
  number: [
    'required',
    'minValue',
    'maxValue',
    'positive',
    'negative',
    'decimalLimit',
  ],
  radio: ['required'],
  text: ['required', 'minLength', 'maxLength', 'pattern'],
  textarea: ['required', 'minLength', 'maxLength', 'pattern'],
};

export const RULE_META: Record<
  string,
  {
    inputType: 'text' | 'number' | 'select' | 'none';
    options?: { label: string; value: string }[];
    placeholder?: string;
    tooltip?: string;
  }
> = {
  required: { inputType: 'none' },
  pastOnly: { inputType: 'none' },
  futureOnly: { inputType: 'none' },
  maxToday: { inputType: 'none' },
  minLength: { inputType: 'number', placeholder: 'e.g., 3' },
  maxLength: { inputType: 'number', placeholder: 'e.g., 10' },

  minValue: { inputType: 'number', placeholder: 'Minimum value' },
  maxValue: { inputType: 'number', placeholder: 'Maximum value' },

  decimalLimit: {
    inputType: 'number',
    placeholder: 'Decimal places (e.g., 2)',
  },

  fileType: {
    inputType: 'select',
    options: [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel (.xlsx)', value: '.xlsx' },
      { label: 'CSV', value: '.csv' },
      { label: 'Word (.doc, .docx)', value: 'application/msword' },
      { label: 'Text (.txt)', value: '.txt' },
      { label: 'Images (JPEG, PNG, etc.)', value: 'image/*' },
    ],
    tooltip: 'Accepted file extensions (choose one)',
  },

  maxFileSize: {
    inputType: 'number',
    placeholder: 'Max file size in KB',
    tooltip: 'Example: 1024 for 1MB',
  },

  pattern: {
    inputType: 'text',
    placeholder: 'e.g., ^[A-Za-z]+$',
    tooltip: 'Regex pattern',
  },

  positive: { inputType: 'none' },
  negative: { inputType: 'none' },
};

export const DEFAULT_ERROR_MESSAGES: Record<string, string> = {
  required: 'This field is required.',
  whitespace: 'Whitespace is not allowed.',
  pattern: 'Invalid format.',
  minLength: 'Too short.',
  maxLength: 'Too long.',
  minValue: 'Value is too low.',
  maxValue: 'Value is too high.',
  decimalLimit: 'Too many decimal places.',
  fileType: 'Unsupported file type.',
  maxFileSize: 'File is too large.',
  positive: 'Value must be positive.',
  negative: 'Value must be negative.',
  pastOnly: 'Date must be in the past.',
  futureOnly: 'Date must be in the future.',
  maxToday: 'Date cannot exceed today.',
};

export const NOTIFICATION_TYPES = {
  SUPER_ADMIN_ASSIGNED: 'super-admin-assigned',
  PROJECT_ADMIN_ASSIGNED: 'project-admin-assigned',
  PROJECT_ASSIGNED: 'project-assigned',
  PROJECT_PUBLISHED: 'project-published',
  PROJECT_UNPUBLISHED: 'project-unpublished',
  FORM_SUBMITTED: 'form-submitted',
  PROJECT_ONBOARDING_INITIATED: 'project-onboarding-initiated',
  FORM_CLOSED: 'form-closed',
};
